import { Injectable, EventEmitter } from '@angular/core';
import { Connection, hubConnection, Proxy } from 'signalr-no-jquery';


@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private connection: Connection;
  private proxyHub: Proxy;
  downloadCompletedEvent = new EventEmitter();
  connectionEvent = new EventEmitter();
  logoutEvent = new EventEmitter();
  sendProgressFileNameEvent = new EventEmitter();
  sendProgressCountEvent = new EventEmitter(); 
  private eventName: any;

  constructor() { }

  public establishHub(proxyhubname: string, eventNames: string | string[]) {
    this.connection = hubConnection();
    this.proxyHub = this.connection.createHubProxy(proxyhubname);
    this.eventName = Array.isArray(eventNames) ? eventNames : [eventNames];
    this.registerOnserverEvents();
    this.startConnection();
    this.reConnect();
  }

  public stopConnection(): void {
    if (this.connection) {
      this.connection.stop();
      this.connection = undefined;
    }
  }

  private startConnection(): void {
    this.connection.start()
      .done(() => {
        this.connectionEvent.emit();
      })
      .fail((error: any) => {
        console.log('Could not connect' + error);
      });
  }

  //Mozilla SignalR disconnection issue
  private reConnect(): void {
    if (navigator.onLine) {
      this.connection.disconnected(() => {
        setInterval(() => {
          if (this.connection) {
            this.connection.start().done(() => {
              this.eventName.forEach((event: string) => {
                this.proxyHub.on(event, (filename: string, count: number) => {
                  setTimeout(() => {
                    if (event == 'downloadComplete') {
                      this.downloadCompletedEvent.emit(filename);
                    }
                    else if (event == 'sendProgressFileName') {
                      this.sendProgressFileNameEvent.emit(filename);
                    }
                    else if (event == 'sendProgressCount') {
                      this.sendProgressCountEvent.emit({ filename, count });
                    }
                    else {
                      this.logoutEvent.emit(filename);
                    }
                  });
                });
              });
            })
          }
        }, 10000) //try to reconnect every 10 seconds, not the best solution but much better than before
      })
    };
  }

  private registerOnserverEvents(): void {
    this.eventName.forEach((event: string) => {
      this.proxyHub.on(event, (filename: string, count: number) => {
        setTimeout(() => {
          if (event == 'downloadComplete') {
            this.downloadCompletedEvent.emit(filename);
          }
          else if (event == 'sendProgressFileName') {
            this.sendProgressFileNameEvent.emit(filename);
          }
          else if (event == 'sendProgressCount') {
            this.sendProgressCountEvent.emit({ filename, count });
          }
          else {
            this.logoutEvent.emit(filename);
          }
        }, 1000);
      });
    });
  }
}
